/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateUserNameRequestUser } from './UpdateUserNameRequestUser';
import {
    UpdateUserNameRequestUserFromJSON,
    UpdateUserNameRequestUserFromJSONTyped,
    UpdateUserNameRequestUserToJSON,
} from './UpdateUserNameRequestUser';

/**
 * 
 * @export
 * @interface UpdateUserNameRequest
 */
export interface UpdateUserNameRequest {
    /**
     * 
     * @type {UpdateUserNameRequestUser}
     * @memberof UpdateUserNameRequest
     */
    user: UpdateUserNameRequestUser;
}

/**
 * Check if a given object implements the UpdateUserNameRequest interface.
 */
export function instanceOfUpdateUserNameRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function UpdateUserNameRequestFromJSON(json: any): UpdateUserNameRequest {
    return UpdateUserNameRequestFromJSONTyped(json, false);
}

export function UpdateUserNameRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNameRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UpdateUserNameRequestUserFromJSON(json['user']),
    };
}

export function UpdateUserNameRequestToJSON(value?: UpdateUserNameRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UpdateUserNameRequestUserToJSON(value.user),
    };
}

